import { createI18n } from 'vue-i18n';
import da from './locales/da.json';

// Add other locales here, e.g.:
// import en from './locales/en.json';

const messages = {
  da: da,
  // en: en,
};

const i18n = createI18n({
  legacy: false, // Use Composition API mode
  locale: 'da', // Set default locale
  fallbackLocale: 'da', // Fallback locale if translation is missing
  messages, // Set locale messages
});

export default i18n; 